import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { scrollContainerTopOffsetSelector } from '../../../store/scrollContainer/selectors'
import { RootState } from '../../../reducers'

export const useCloseMenuAfterScroll = (setOpen: (value: boolean) => void) => {
  // This way we don't trigger re-renders on every scroll, but only when the threshold is breached
  const isOverThreshold = useSelector(
    (state: RootState) => scrollContainerTopOffsetSelector(state) > 100
  )

  useEffect(() => {
    if (isOverThreshold) {
      setOpen(false)
    }
  }, [isOverThreshold, setOpen])
}
